// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'

const clearASRValues = sourceForm => (dispatch, getState) => {

  const initialValues = {
    asr: '',
    latitude: '',
    longitude: '',
    radius: '',
  }

  dispatch(initialize(sourceForm, initialValues))
}

export default clearASRValues